import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

export const focusAndSelectField = (
  el: HTMLTextAreaElement | HTMLInputElement | null,
) => {
  if (!el) {
    return
  }

  setTimeout(() => {
    el.focus()
    el.select()
  }, 0)
}

export const InlineEditButtons = ({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void
  onCancel: () => void
}) => (
  <div className="mr-2 flex">
    <button
      className="flex-none text-green-500 hover:text-green-700"
      onMouseDown={(e) => e.preventDefault()}
      onClick={onConfirm}
    >
      <CheckIcon fontSize="small" />
    </button>
    <button
      className="flex-none text-red-400 hover:text-red-600"
      onMouseDown={(e) => e.preventDefault()}
      onClick={onCancel}
    >
      <CloseIcon fontSize="small" />
    </button>
  </div>
)
